import React from 'react';
import PropTypes from 'prop-types';
import { Box, ButtonBase } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const ShowMoreButton = ({ onClick }) => (
  <ButtonBase style={{ width: '100%' }} onClick={onClick}>
    <Box
      width="100%"
      display="flex"
      justifyContent="space-between"
      pt={3}
      pb={3}
      pl={10}
      pr={10}
    >
      <div>Afficher plus</div>
      <ExpandMoreIcon />
    </Box>
  </ButtonBase>
);

ShowMoreButton.propTypes = {
  onClick: PropTypes.func
};

export default ShowMoreButton;
